export const CookieFunction = {
  setCookie(keyName: string, value: string) {
    const d = new Date();

    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);

    const expires = 'expires=' + d.toUTCString();
    document.cookie = keyName + '=' + decodeURIComponent(value) + ';' + expires + ';path=/';
  },

  getCookie(keyName: string) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(keyName + '=');
      if (start !== -1) {
        start = start + keyName.length + 1;
        let end = document.cookie.indexOf(';', start);
        if (end === -1) end = document.cookie.length;
        return unescape(document.cookie.substring(start, end));
      }
    }
    return '';
  },
  clearLoginForm() {
    CookieFunction.setCookie('username', '');
    CookieFunction.setCookie('passwd', '');
  },
  updateLoginForm(username?: string, passwd?: string) {
    if (username) {
      CookieFunction.setCookie('username', username);
    }
    if (passwd) {
      CookieFunction.setCookie('passwd', passwd);
    }
  }
};
